let floatAdded = false;
let footerVisible = false;


$(window).on('load scroll', function () {
  const scrollTop = $(this).scrollTop();
  if (scrollTop > 700 && !footerVisible) {
    if (!floatAdded) {
      $('.banner').addClass('is-active');
      $('.float-nav').addClass('is-active');
      floatAdded = true;
    }
  } else {
    if (floatAdded) {
      $('.banner').removeClass('is-active');
      $('.float-nav').removeClass('is-active');
      floatAdded = false;
    }
  }
});


const footerObserver = new IntersectionObserver(function (entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      $('.banner').removeClass('is-active');
      $('.float-nav').removeClass('is-active');
      footerVisible = true;
    } else {
      footerVisible = false;
      if ($(window).scrollTop() > 700) {
        $('.banner').addClass('is-active');
        $('.float-nav').addClass('is-active');
      }
    }
  });
});

footerObserver.observe(document.querySelector('footer'));

$('.banner').find('.close').on('click', function () {
  $(this).parent().fadeOut(200);
})
